import { Outlet } from 'react-router-dom'
import { useAdapterStatus } from '../adapters/AdapterProvider'
import { LanguageSwitcher } from './LanguageSwitcher'
import { LeftNav } from './LeftNav'
import { UserMenu } from './UserMenu'

export function AppShell() {
  const adapterStatus = useAdapterStatus()

  return (
    <div className="flex h-screen bg-stone-50 text-stone-900 dark:bg-stone-950 dark:text-stone-50">
      <LeftNav />
      <div className="flex flex-1 flex-col overflow-hidden">
        <header className="flex h-14 items-center justify-end gap-3 border-b border-stone-200 bg-white px-4 dark:border-stone-800 dark:bg-stone-900">
          <LanguageSwitcher />
          <UserMenu />
        </header>
        <main className="flex-1 overflow-auto">
          {adapterStatus.kind === 'error' ? (
            <div
              data-testid="adapter-error-panel"
              className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center"
            >
              <h2 className="text-lg font-semibold text-stone-800 dark:text-stone-200">
                Couldn't start the designer
              </h2>
              <p className="text-sm text-stone-600 dark:text-stone-400">
                {adapterStatus.message}
              </p>
              <p className="text-sm text-stone-500 dark:text-stone-400">
                Please reload the page to try again.
              </p>
            </div>
          ) : (
            <Outlet />
          )}
        </main>
      </div>
    </div>
  )
}
